import axios from 'axios';

export default axios.create({
  baseURL: 'https://beta.dongnaibr.vn/',
  headers: {
    'Content-type': 'application/json',
  },
});
